import _ from 'lodash';

// elsa-v3's cashflow route (elsa-v3/src/router: /cashflow-real/:tab?). The home tab is the
// redesign's landing screen; a direct hit on the Vue 2 cashflow keeps the cashflow tab.
const V3_CASHFLOW_PATH = '/v3/cashflow-real';
const V3_HOME_PATH = `${V3_CASHFLOW_PATH}/home`;

// Only these keys follow the customer into v3. An allow-list, because the login flow and
// login-as put the phone number and tokens (accessToken, inviteToken) in the query, and the
// state router forwards the whole query to the home route.
const FORWARDED_QUERY_KEYS = ['openChatbot', 'chatbotMessage'];

// Query keys neither cashflow acts on: login plumbing and debug switches.
const IGNORED_QUERY_KEYS = ['phoneNumber', 'accessToken', 'inviteToken', 'redirectTo', 'showIntercom', 'debug_performance'];

// Route names carry a Web_/Mob_ prefix in the webview tiers, hence endsWith.
function isCashflowAppRoute(routeName) {
  return _.endsWith(routeName, 'CashflowApp');
}

function isForwardedKey(key) {
  return _.startsWith(key, 'utm_') || _.includes(FORWARDED_QUERY_KEYS, key);
}

// vue-router gives repeated keys as arrays; Vue 2's deep links take the first value.
function firstValue(value) {
  return Array.isArray(value) ? value[0] : value;
}

// Why a customer in the flag still gets the Vue 2 cashflow for this navigation, or null.
// Any query key the Vue 2 cashflow might act on (deep links, promo codes, the dormant-reset
// marker, month hints) keeps the customer there: v3 serves none of them yet, so an unknown
// key is safer in Vue 2 than silently dropped.
function legacyReasonFor({ query = {}, params = {} } = {}, { incognito = false, optedOut = false } = {}) {
  // Login-as sessions: v3 does not honor incognito yet, so the agent would be tracked and
  // booted into Intercom as the customer.
  if (incognito || query.incognito) {
    return 'incognito';
  }
  // The customer just used v3's hidden escape hatch to get here (see redesign.js).
  if (optedOut) {
    return 'opt-out';
  }
  const legacyKey = _.find(
    _.keys(query),
    key => !_.isNil(query[key]) && !isForwardedKey(key) && !_.includes(IGNORED_QUERY_KEYS, key),
  );
  if (legacyKey) {
    return `query:${legacyKey}`;
  }
  // v3 has no month navigation: explicit months stay where they can be shown.
  if (params.budgetDate && params.budgetDate !== 'current') {
    return 'budget-date';
  }
  return null;
}

function redesignPathFor(routeName) {
  return isCashflowAppRoute(routeName) ? V3_CASHFLOW_PATH : V3_HOME_PATH;
}

function redesignUrlFor(routeName, query = {}) {
  const path = redesignPathFor(routeName);
  const forwarded = _.omitBy(_.mapValues(_.pickBy(query, (value, key) => isForwardedKey(key)), firstValue), _.isNil);
  const search = new URLSearchParams(forwarded).toString();
  return search ? `${path}?${search}` : path;
}

export default { legacyReasonFor, redesignPathFor, redesignUrlFor };
